// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__jQ0qX","errorLogs":"EditorFooter_errorLogs__2tqz2"};